import { Link } from 'react-router-dom'
import { periodToRange } from '../../api/dashboards'
import { executiveApi } from '../../api/executive'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { Stat, WidgetBody, formatNum } from './WidgetBody'

const count = (c: number | null): string => (c === null ? '—' : formatNum(c))

/** Produzione della Direzione: conteggi di pratiche, nessun importo. Solo Manager (il server risponde 403 agli altri). */
export function ExecutiveProductionWidget({ item }: WidgetProps) {
  const range = periodToRange(item.filters?.period)
  const state = useWidgetData(() => executiveApi.get(range), JSON.stringify(range))
  return (
    <WidgetBody state={state}>
      {r => (
        <>
          <div className="md-mini-stats">
            <Stat label="Inserite" value={count(r.production.inserted.count)} />
            <Stat label="Inviate" value={count(r.production.submitted.count)} />
            <Stat label="Attivate" value={count(r.production.activated.count)} />
            <Stat label="Stornate" value={count(r.production.reversed.count)} />
          </div>
          <Link to="/reports/executive" className="md-typescale-body-small d-inline-block mt-2">
            Apri il cockpit
          </Link>
        </>
      )}
    </WidgetBody>
  )
}
